/***
 * Created on 2024/2/20
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useRef} from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useQnapAuthAppBindCheck} from "../../../../../hook/qnap_auth_app_bind_check";
import BindQnapAuthAppSuccess from "./bind_qnap_auth_app_success";
import ShowQnapAuthAppQrcode from "./show_qnap_auth_app_qrcode";
import QnapAuthAppStepContent from "./qnap_auth_app_step_content";
import ShowQnapAuthAppTotpQrcode from "./show _qnap_auth_app_totp_qrcode";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../../../../service/api";

function ScanQrCode({dispatch, state, ...props}) {
    const { t } = useTranslation();
    const {status, device} = useQnapAuthAppBindCheck(state?.method === 'qrcode');
    const modalRef = useRef();

    const onBackMutation = useMutation({
        mutationFn: async () => await apiPost('/ajax/qnap_auth/cancel', null)
    });

    const onSubmitAction = () => {
        if (state.method === 'approval') {
            dispatch({type: 'toggleShowApproval', value: true})
        }
        else {
            onBackMutation.mutate();
            dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: true, method: null});
        }
    }

    const submitText = () => {
        return state.method === 'approval' ? t('@Next@') : t('@Back@');
    }

    useEffect(() => {
        if (status === 'valid' && device?.device_id) {
            dispatch({type: 'toggleShowSuccess', value: true, device});
        }
    }, [status, device?.device_id]);

    return (
        <ModalDialog {...props} title={t('@Verify through an app@')}
                     submitText={submitText()} submitAction={onSubmitAction}
                     withWizardMode={true} withStepBar={true}
                     hideSubmit={state.method === 'approval'}
                     stepContent={() => QnapAuthAppStepContent({state, step: 2})} ref={modalRef}>
            <div className="dialog-content dialog-content--two-step">
                {status !== 'valid' && state.method !== 'totp' && <ShowQnapAuthAppQrcode state={state} dispatch={dispatch} modalRef={modalRef}/>}
                {status !== 'valid' && state.method === 'totp' && <ShowQnapAuthAppTotpQrcode state={state} dispatch={dispatch} modalRef={modalRef}/> }

                {/*{status === 'valid' && <BindQnapAuthAppSuccess result={device} state={state} modalRef={modalRef}/>}*/}
            </div>
        </ModalDialog>
    );
}

export default ScanQrCode;
